import {
  DateFormat,
  Tag,
  TagColor,
  ProviderAvatarBlock,
  formatPhoneNumberForTextInputV2,
  ChakraFlex,
} from '@equip.health/ui';
import { DateTime } from 'luxon';
import { getLatestOutOfOfficeEndDate } from '~/lib/util/profile.util';

interface UserTableRowProps {
  id: string;
  user: GetProviderByIdResponse;
}

const UserTableRow = ({ id, user }: UserTableRowProps) => {
  const legalName = {
    firstName: user?.firstName,
    lastName: user?.lastName,
    middleName: user?.middleName,
    suffix: user?.suffix,
  };

  const displayName = {
    firstName: user?.displayFirstName,
    lastName: user?.displayLastName,
    middleName: user?.displayMiddleName,
    suffix: user?.displaySuffix,
  };

  const isDisplayName = displayName.firstName && displayName.lastName;
  const credentials = user?.credentialsDetails.map(
    (credential) => credential.code,
  );

  const oooEndDate = getLatestOutOfOfficeEndDate(user?.outOfOffice);

  const deactivatedDate = DateTime.fromISO(user?.deactivatedDate).startOf(
    'day',
  );
  const deactivatedDateFormatted = deactivatedDate?.isValid
    ? deactivatedDate.toFormat(DateFormat.fullMonthDayYear)
    : '';

  const statusTag =
    user.userStatus.toLowerCase() === 'active' ? (
      <Tag color={TagColor.green} id={`${id}__active`} value="Active" />
    ) : (
      <Tag color={TagColor.gray} id={`${id}__inactive`} value="Inactive" />
    );

  return {
    key: user.userId,
    object: {
      email: user.email,
      name: (
        <ProviderAvatarBlock
          avatarUrl={user?.avatar?.thumbnailUrl || user?.avatar?.url}
          credentials={credentials}
          deactivatedDate={deactivatedDateFormatted}
          displayName={isDisplayName && displayName}
          id={`${id}__avatar-block`}
          legalName={legalName}
          oooDate={oooEndDate}
          providerTypeName={user.providerTypeDetails.name}
          shouldShowCredentials
          shouldShowDeactivatedDate
          shouldShowOOOIcon={oooEndDate !== null}
          shouldShowProviderType
          variant="standard"
        />
      ),
      phoneNumber: formatPhoneNumberForTextInputV2(user.phoneNumber),
      status: <ChakraFlex marginLeft="10px">{statusTag}</ChakraFlex>,
    },
  };
};

export default UserTableRow;
